/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileZipTaskStatus,
    CaseFileZipTaskStatusFromJSON,
    CaseFileZipTaskStatusFromJSONTyped,
    CaseFileZipTaskStatusToJSON,
    ZipUrl,
    ZipUrlFromJSON,
    ZipUrlFromJSONTyped,
    ZipUrlToJSON,
} from './';

/**
 * 
 * @export
 * @interface InterrogatoryFileZipView
 */
export interface InterrogatoryFileZipView {
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryFileZipView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryFileZipView
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryFileZipView
     */
    firmId?: string;
    /**
     * 
     * @type {Date}
     * @memberof InterrogatoryFileZipView
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InterrogatoryFileZipView
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {CaseFileZipTaskStatus}
     * @memberof InterrogatoryFileZipView
     */
    status?: CaseFileZipTaskStatus;
    /**
     * 
     * @type {number}
     * @memberof InterrogatoryFileZipView
     */
    progressPercentage?: number;
    /**
     * 
     * @type {Array<ZipUrl>}
     * @memberof InterrogatoryFileZipView
     */
    zipUrls?: Array<ZipUrl> | null;
}

export function InterrogatoryFileZipViewFromJSON(json: any): InterrogatoryFileZipView {
    return InterrogatoryFileZipViewFromJSONTyped(json, false);
}

export function InterrogatoryFileZipViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterrogatoryFileZipView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'firmId': !exists(json, 'firmId') ? undefined : json['firmId'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'status': !exists(json, 'status') ? undefined : CaseFileZipTaskStatusFromJSON(json['status']),
        'progressPercentage': !exists(json, 'progressPercentage') ? undefined : json['progressPercentage'],
        'zipUrls': !exists(json, 'zipUrls') ? undefined : (json['zipUrls'] === null ? null : (json['zipUrls'] as Array<any>).map(ZipUrlFromJSON)),
    };
}

export function InterrogatoryFileZipViewToJSON(value?: InterrogatoryFileZipView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'firmId': value.firmId,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'status': CaseFileZipTaskStatusToJSON(value.status),
        'progressPercentage': value.progressPercentage,
        'zipUrls': value.zipUrls === undefined ? undefined : (value.zipUrls === null ? null : (value.zipUrls as Array<any>).map(ZipUrlToJSON)),
    };
}


